export const data = {
    // experience: [
    //     {
    //         title: "Job Title 1",
    //         subTitle: "Company 1",
    //         description: "Description for Job Title 1",
    //     },
    //     {
    //         title: "Job Title 2",
    //         subTitle: "Company 2",
    //         description: "Description for Job Title 2",
    //     },
    //     // Add more experience entries if needed
    // ],
    education: [
        {
            title: "Standard 10th : 80%",
            subTitle: "A.S Krishna Niketan",
            description: "Patna, Bihar",
        },
        {
            title: "Standard 12th : 80% ",
            subTitle: "Satyam International School",
            description: "Patna, Bihar",
        },
        {
            title: "Bachleor's of Engineering and Technology : 8.67 CGPA",
            subTitle: "Chitkara Uniersity",
            description: "Rajpura, Punjab",
        }
    ]
};
